import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getServiceOfferings, getServiceTypes } from 'wasp/client/operations';

export default function ServiceOfferingListPage() {
  const [selectedTypeId, setSelectedTypeId] = useState<string>('');

  const { data: serviceTypes, isLoading: typesLoading } = getServiceTypes() as any;
  const { data: offerings, isLoading: offeringsLoading } = getServiceOfferings({
    serviceDefinitionId: selectedTypeId || undefined
  }) as any;

  const isLoading = typesLoading || offeringsLoading;

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Available Services
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Find services currently available at locations near you
          </p>
        </div>

        {/* Filters */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mb-8">
          <div>
            <label htmlFor="serviceType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Filter by Service Type
            </label>
            <select
              id="serviceType"
              value={selectedTypeId}
              onChange={(e) => setSelectedTypeId(e.target.value)}
              className="w-full md:w-64 px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Service Categories</option>
              {serviceTypes?.map((type: any) => (
                <option key={type.id} value={type.id}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Results */}
        {isLoading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            <p className="mt-4 text-gray-600 dark:text-gray-400">Loading services...</p>
          </div>
        ) : offerings && offerings.length === 0 ? (
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-12 text-center">
            <p className="text-gray-600 dark:text-gray-400 text-lg mb-4">
              No services currently available
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-500">
              Try adjusting your filters or check back later
            </p>
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2">
            {offerings?.map((offering: any) => (
              <Link
                key={offering.id}
                to={`/discover-services/offerings/${offering.id}` as any}
                className="block bg-white dark:bg-gray-800 rounded-lg shadow hover:shadow-lg transition p-6"
              >
                <div className="mb-4">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                    {offering.customName || offering.serviceDefinition.name}
                  </h3>
                  <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
                    {offering.serviceDefinition.serviceType.label}
                  </span>
                </div>

                <div className="space-y-3">
                  <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Location</p>
                    <p className="text-gray-600 dark:text-gray-400">{offering.location.name}</p>
                  </div>

                  {offering.organization && (
                    <div>
                      <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Organization</p>
                      <p className="text-gray-600 dark:text-gray-400">{offering.organization.name}</p>
                    </div>
                  )}

                  {offering.scheduleType && (
                    <div>
                      <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Schedule</p>
                      <span className="inline-block px-3 py-1 text-xs font-medium rounded bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300 capitalize">
                        {offering.scheduleType}
                      </span>
                    </div>
                  )}

                  {offering.hasCapacity && offering.maxCapacity && (
                    <div>
                      <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Capacity</p>
                      <p className="text-gray-600 dark:text-gray-400">
                        {offering.currentAttendees} / {offering.maxCapacity} spots filled
                      </p>
                    </div>
                  )}
                </div>

                {offering.customDescription && (
                  <p className="text-gray-600 dark:text-gray-400 text-sm mt-4 pt-4 border-t border-gray-200 dark:border-gray-700 line-clamp-2">
                    {offering.customDescription}
                  </p>
                )}

                {offering.requiresRegistration && (
                  <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200">
                      Registration Required
                    </span>
                  </div>
                )}
              </Link>
            ))}
          </div>
        )}
    </div>
  );
}



